<template>
  <div class="warpBox">
    <div class="headertop">
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row class="headerBoxRow">
          <a-col class="m-r">
            <a-form-model-item label="用户uid" prop="uid">
              <a-input v-model="formInline.uid" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col class="m-r">
            <a-form-model-item label="手机号码" prop="phone">
              <a-input
                v-model="formInline.phone"
                type="user"
                placeholder="请输入"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col class="m-r">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ minHeight: '360px' }">
        <memberManagementContent
          :formInline="formInline"
          ref="aaa"
        ></memberManagementContent>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import { storeListEditXiala } from "@/api/homeApi.js";
import memberManagementContent from "./memberManagementContent.vue";
export default {
  components: {
    memberManagementContent,
  },
  data() {
    return {
      formInline: {
        orderNo: "",
        uid: "",
        phone: "",
        store: "",
      },
      xiala: [],
    };
  },
  created() {
    this.getStoreListEditXiala();
  },
  methods: {
    seach() {
      console.log(this.formInline);
      this.$refs.aaa.queryData();
    },
    getStoreListEditXiala() {
      storeListEditXiala({ limit: 10, page: 1 }).then((res) => {
        this.xiala = res.data;
      });
    },
    storeType(e) {
      this.formInline.store = e;
      console.log("oooooooooooooooooop", e);
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.$refs.aaa.handleGetMembersList();
    },
    handleChange() {
      console.log("click handleChange");
    },

    // ---------

    handleMemberSeach() {},
  },
};
</script>

<style lang="scss" scoped>
.warpBox {
  padding: 25px;
}
.headertop {
  background-color: #fff;
}
.headerBoxRow {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  margin-left: 20px;
  .m-r {
    margin-right: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/memberManagement/memberManagementTop.vue